var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomateIconMarketplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 5C4.30044 5 5 4.30044 5 3.4375C5 2.57456 4.30044 1.875 3.4375 1.875C2.57456 1.875 1.875 2.57456 1.875 3.4375C1.875 4.30044 2.57456 5 3.4375 5ZM3.4375 5V10M3.4375 10C2.57456 10 1.875 10.6996 1.875 11.5625C1.875 12.4254 2.57456 13.125 3.4375 13.125C4.30044 13.125 5 12.4254 5 11.5625C5 10.6996 4.30044 10 3.4375 10ZM11.5625 10V5.4375C11.5625 4.73744 11.5625 4.3874 11.4262 4.12001C11.3064 3.88481 11.1152 3.69358 10.88 3.57374C10.6126 3.4375 10.2626 3.4375 9.5625 3.4375H7.5M11.5625 10C12.4254 10 13.125 10.6996 13.125 11.5625C13.125 12.4254 12.4254 13.125 11.5625 13.125C10.6996 13.125 10 12.4254 10 11.5625C10 10.6996 10.6996 10 11.5625 10ZM7.5 3.4375L9.0625 5M7.5 3.4375L9.0625 1.875",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomateIconMarketplace);
export default __webpack_public_path__ + "static/media/automateIconMarketplace.4dcc0677ff1c9a388c0072d406bc6378.svg";
export { ForwardRef as ReactComponent };